// extracted by mini-css-extract-plugin
export default {"swiper_box":"index_swiper_box_-hDyo","swiper":"index_swiper_BnKtY","swiper_item":"index_swiper_item_JdYo0"};